import Button, { ButtonProps } from '~/components/interactive/Button';
import { NavLink, useResolvedPath } from '@remix-run/react';
import IconLoading from '~/components/icons/streamline/line/IconLoading';
import classNames from 'classnames';

export type NavigationButtonProps = Omit<ButtonProps, 'onClick' | 'type'> & {
  to: string;
  popup?: boolean;
  download?: string;
};

export default function NavigationButton({ to, popup, icon, ...props }: NavigationButtonProps) {
  const path = useResolvedPath(to);

  return (
    <NavLink
      to={props.disabled ? '#' : to}
      download={props.download}
      viewTransition
      className={classNames('inline-flex *:flex-1', { 'cursor-not-allowed': props.disabled })}
      onClick={(e) => {
        if (props.disabled) {
          e.preventDefault();
        }
      }}
    >
      {({ isPending }) => (
        <Button
          {...props}
          icon={isPending ? <IconLoading /> : icon}
          disabled={props.disabled || isPending}
          type="button"
          onClick={(e) => {
            if (props.download) {
              return;
            }

            if ((to.includes('http') && popup !== false) || popup) {
              window.open(to.includes('http') ? to : path.pathname + path.search, '_blank');

              e.preventDefault();

              return;
            }
          }}
        />
      )}
    </NavLink>
  );
}
